import api, { BASE_URL } from './api';

class PatientService {
  // Get patients for a specific medical center (single scoped call)
  async getPatients(medicalCenterId) {
    if (!medicalCenterId) {
      throw new Error('Medical Center ID is required');
    }
    return await api.get(`${BASE_URL}/medical_centers/${medicalCenterId}/patients`);
  }

  // Get single patient within a medical center
  async getPatient(patientId, medicalCenterId) {
    if (!medicalCenterId) {
      throw new Error('Medical Center ID is required');
    }
    return await api.get(`${BASE_URL}/medical_centers/${medicalCenterId}/patients/${patientId}`);
  }

  // Create new patient in a medical center
  async createPatient(patientData, medicalCenterId) {
    if (!medicalCenterId) {
      throw new Error('Medical Center ID is required to create a patient');
    }
    return await api.post(`${BASE_URL}/medical_centers/${medicalCenterId}/patients`, {
      patient: patientData
    });
  }

  // Update patient in a medical center
  async updatePatient(patientId, patientData, medicalCenterId) {
    if (!medicalCenterId) {
      throw new Error('Medical Center ID is required to update a patient');
    }
    return await api.put(
      `${BASE_URL}/medical_centers/${medicalCenterId}/patients/${patientId}`,
      { patient: patientData }
    );
  }

  // Delete patient in a medical center
  async deletePatient(patientId, medicalCenterId) {
    if (!medicalCenterId) {
      throw new Error('Medical Center ID is required to delete a patient');
    }
    return await api.delete(
      `${BASE_URL}/medical_centers/${medicalCenterId}/patients/${patientId}`
    );
  }

  // Calculate stats from patients data (no extra API calls)
  async calculateStats(patients) {
    const totalPatients = patients.length;

    const activePatients = patients.filter(p => p.status === 'Active').length;
    const inactivePatients = patients.filter(p => p.status === 'Inactive').length;

    const successRate =
      totalPatients > 0 ? Math.round((activePatients / totalPatients) * 100) : 0;

    return {
      totalPatients,
      activePatients,
      inactivePatients,
      successRate
    };
  }
}

export const patientService = new PatientService();